import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from "@angular/router";

import {HttpCommonService} from "../services/http-common.service";
import {NzMessageService} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {GlobalService} from "../services/global.service";

@Injectable()
export class CheckCreditGuard implements CanActivate {

  constructor(private msg: NzMessageService,
              private globalService: GlobalService,
              public http: HttpCommonService) {
  }

  canActivate(routerInfo: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.globalService.getUserInfo("_userType") != 'enterprise') {
      this.msg.error("该功能只对机构用户开放，如有需要请联系客服！");
      return false;
    }

    return this.http.get("/user/center/xhsRest/hasPermission", {permissionId: "company:checkCredit"}).map((result) => {
      // 已登录
      if (result.data > 0) {
        return true;
      } else {
        this.msg.error("该功能只对机构用户开放，如有需要请联系客服");
        return false;
      }
    }).first();

  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/guard/checkCreditGuard.ts